import React from "react";
import _ from "lodash";

export const getCenterSelectorPosition = (nodes, selectorId) => {
  const assetCardNode = nodes.find((node) => node.id === selectorId);
  // Calculate the position for the new Selector node
  return {
    x: assetCardNode.position.x + assetCardNode.measured?.width / 2 - 22, // Centered below the AssetCard
    y: assetCardNode.position.y + (assetCardNode.measured?.height || 50) + 100, // 200px below
  };
};

export const getRecursiveChildEdges = (edges, nodeId) => {
  const childEdges = [];

  // Recursive function to find all edges with the source as the current nodeId
  const findEdges = (sourceId) => {
    edges.forEach((edge) => {
      if (edge.source === sourceId) {
        childEdges.push(edge); // Add edge to result array
        findEdges(edge.target); // Recursively find edges that start from the target of this edge
      }
    });
  };

  findEdges(nodeId); // Start the search from the provided nodeId

  return childEdges; // Return the array of all recursive child edges
};

export const constructCommands = (filter, conditional) => {
  return processRequestFilters(filter, conditional);
};

export function processRequestFilters(filters = [], sourceType) {
  if(_.size(filters) == 0) {
    return []
  }

  return filters.map(({ property, operator, value }) => {
    // Check for "no_source" and modify the operator
    if (sourceType === "no_source") {
      operator = getOppositeOperator(operator); // Function to get the opposite operator
    }

    if (property.type == "ASSET") {
      const mapping = _.head(value);
      value = [mapping?.id];
    }

    return {
      property,
      operator,
      value,
    };
  });
}

function getOppositeOperator(operator) {
  const oppositeOperators = {
    IS_LESS_THAN: "IS_GREATER_THAN",
  };

  return oppositeOperators[operator] || operator; // Return opposite operator if found, else return the same
}

export const getSourceHandle = (connector) => {
  const filters = _.head(connector.filters);
  if (filters) {
    switch (filters.operator) {
      case "IS_LESS_THAN":
        return true;
      case "IS_GREATER_THAN":
        return false;
    }
  }
};

export const getParentNode = (connectors = [], steps = [], stepId) => {
  if (stepId) {
    const parent = _.find(connectors, (connector) => {
      return connector.end === stepId;
    });
    if (parent) {
      return _.find(steps, (node) => {
        return node.id === parent.start;
      });
    }

    return null;
  }
};


export const calculateNodePositions = (steps, connectors, startPosition) => {
  const positions = {};
  let calculatedSteps = new Set();
  const baseHorizontalSpacing = 400; // Starting spacing for shallow nodes
  const minHorizontalSpacing = 10;


  const getHorizontalSpacing = (depth) => {
    const spacing = baseHorizontalSpacing / (depth);
    return Math.max(spacing, minHorizontalSpacing); // Ensure it doesn't go below minimum
  };

  const calculatePosition = (stepId, position, depth = 0) => {

    if (calculatedSteps.has(stepId)) return;

    const step = _.find(steps, { id: stepId });
    if (!step) return;
    // Set the current node position

    positions[stepId] = position;
    calculatedSteps.add(stepId);
    // Get children connected to the current step
    const childConnectors = connectors.filter(
      (connector) => connector.start === stepId
    );

    // Calculate child node positions
    childConnectors.forEach((connector, index) => {
      const nextStep = _.find(steps, { id: connector.end });

      if (nextStep) {
        const horizontalOffset = getHorizontalSpacing(depth);
        const contentDimension = { width: 224, height: 166 };
        const conditionDimension = {
          width: 150,
          height: 150,
        };

        switch (step.type) {
          case "CONTENT":
            const parentPosition = positions[stepId];
            const currentDimention = nextStep.type == 'CONTENT' ? contentDimension : conditionDimension;

            const parentCenterY = parentPosition.y + contentDimension.height / 2;
            const newY = parentCenterY - currentDimention.height / 2; // Center the child vertically
            const newX =
              parentPosition.x +
              contentDimension.width / 2 -
              currentDimention.width / 2;
            // Calculate new position for the child step, horizontally centering it

            
            const newPosition = {
              x: newX, // Adjust x based on index
              y: newY + 250, // Space vertically
            };

            // Recursively calculate the next step's position
            calculatePosition(nextStep.id, newPosition, depth + 1);
            break;

          case "CONDITION":
            const conditionNodePosition = positions[stepId];
            const nodeDimention = nextStep.type == 'CONTENT' ? contentDimension : conditionDimension;

            const sourceHandle = getSourceHandle(connector);
            if (sourceHandle) {
              const yesSourcePosition = {
                x:
                  conditionNodePosition.x +
                  conditionDimension.width +
                  300 + horizontalOffset, // Centered below the AssetCard
                y:
                  conditionNodePosition.y +
                  conditionDimension.height +
                  100, // 200px below
              };

                calculatePosition(nextStep.id, yesSourcePosition, depth + 3);
            }

            const noSourcePosition = {
              x:
                conditionNodePosition.x -
                nodeDimention.width -
                300 - horizontalOffset, // Centered below the AssetCard
              y:
                conditionNodePosition.y +
                conditionDimension.height +
                100, // 200px below
            };

            calculatePosition(nextStep.id, noSourcePosition, depth + 3);
            break;

          default:
            break;
        }
      }
    });
  };

  // Find the start step
  const startStep = _.find(steps, { start: true });

  if (startStep) {
    // Set the start step's position manually to the given startPosition
    calculatePosition(startStep.id, startPosition);
  }

  return positions;
};

export const getRecursiveChildNodes = (nodes, nodeId) => {
  const childNodes = [];

  // Recursive function to find all child nodes
  const findChildren = (parentId) => {
    nodes.forEach((node) => {
      if (node.parentNode === parentId) {
        childNodes.push(node.id); // Add child node to the result array
        findChildren(node.id); // Recursive call to find the child's children
      }
    });
  };

  findChildren(nodeId); // Start the recursive search with the given nodeId

  return childNodes; // Return the array of all child nodes (recursive)
};
